const languagePack = {
  _language: 'en',
  Menu: {
    home: '',
    tournaments: 'Tournaments',
    dashboard: 'Dashboard',
    wallet: 'Wallet',
    leadboard: 'Leaderboard',
    settings: 'Settings',
    referrals: 'Referrals',
    more: 'More',
  },
  HomeMenu: {
    about: 'About',
    faq: 'Faq',
    referrals: 'Referrals',
    /* */
    signIn: 'Login',
    signUp: 'Sign Up',
  },
  Dashboard: {
    balance: 'Balance',
    refresh: 'Refresh',
  },
  User: {
    connected: 'Connected',
  },
  Profile: {
    bonusLevel: 'Your Bonus Level',
    boost: 'Boost',
    boostMultiplier: 'Boost Your Bonus Multiplier Now!',
  },
};

export default languagePack;
